import { domToReact, Element } from 'html-react-parser';

export const parseDiv = ({ children }: Element): React.JSX.Element => <div>{domToReact(children)}</div>;
